import { render, staticRenderFns } from "./ActionMinute.vue?vue&type=template&id=0fbb534d"
import script from "./ActionMinute.vue?vue&type=script&lang=js"
export * from "./ActionMinute.vue?vue&type=script&lang=js"
import style0 from "./ActionMinute.vue?vue&type=style&index=0&id=0fbb534d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports